'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var IconClose = (0, _createIconComponent2.default)({
  fillContent: _react2.default.createElement('g', null, _react2.default.createElement('path', {
    d: 'M14.3 12.179a.25.25 0 0 1 0-.354l9.263-9.262A1.5 1.5 0 0 0 21.439.442L12.177 9.7a.25.25 0 0 1-.354 0L2.561.442A1.5 1.5 0 0 0 .439 2.563L9.7 11.825a.25.25 0 0 1 0 .354L.439 21.442a1.5 1.5 0 0 0 2.122 2.121l9.262-9.263a.25.25 0 0 1 .354 0l9.262 9.263a1.5 1.5 0 0 0 2.122-2.121z'
  })),
  lightContent: _react2.default.createElement('g', null, _react2.default.createElement('path', {
    d: 'M23.5 23.999a.5.5 0 0 1-.354-.146L12 12.706.854 23.853a.5.5 0 1 1-.708-.707L11.292 12 .147.853A.5.5 0 0 1 .854.145L12 11.292 23.147.146a.5.5 0 1 1 .708.707L12.707 11.999l11.146 11.146a.5.5 0 0 1-.353.854z'
  })),
  regularContent: _react2.default.createElement('g', null, _react2.default.createElement('path', {
    d: 'M23.25 23.999a.743.743 0 0 1-.53-.22L12 13.06 1.28 23.779a.744.744 0 0 1-1.06 0 .752.752 0 0 1 0-1.061l10.72-10.72L.22 1.279C.078 1.138 0 .949 0 .749S.078.36.22.219c.141-.142.33-.22.53-.22s.389.078.53.22L12 10.938 22.72.218a.744.744 0 0 1 1.06 0 .747.747 0 0 1 0 1.061l-10.72 10.72 10.72 10.72a.752.752 0 0 1 0 1.061.746.746 0 0 1-.53.219z'
  })),
  height: undefined,
  width: undefined,
  viewBox: "0 0 24 24"
});
IconClose.displayName = 'IconClose';
exports.default = IconClose;